



































































import ToUsersEnum from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/Enums/ToUsersEnum";
import PushMessageTranslationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/PushMessageTranslationsRequest";
import SendCustomMessageRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/SendCustomMessageRequest";
import NotificationTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationTypeEnum";
import Vue from "vue";
import { Component, Model, Watch, Prop } from "vue-property-decorator";

@Component
export default class SendPushModalComponent extends Vue {
  @Model("change", { type: Boolean }) isShow: boolean;
  @Prop({ type: Boolean, default: true }) isLoading: boolean;
  innerShow = false;
  vm = new SendCustomMessageRequest();
  languages: string[] = [];
  toUserTypes = [
    // { id: null, text: 'Выберите' },
    { id: ToUsersEnum.All, text: this.$options.filters['ToUsersEnum'](ToUsersEnum.All) },
    { id: ToUsersEnum.FreeTariff, text: this.$options.filters['ToUsersEnum'](ToUsersEnum.FreeTariff) }
  ];
  notificationTypes = [
    // { id: null, text: 'Выберите' },
    { id: NotificationTypeEnum.Email, text: this.$options.filters['NotificationTypeEnum'](NotificationTypeEnum.Email) },
    { id: NotificationTypeEnum.Push, text: this.$options.filters['NotificationTypeEnum'](NotificationTypeEnum.Push) },
    { id: NotificationTypeEnum.Both, text: this.$options.filters['NotificationTypeEnum'](NotificationTypeEnum.Both) }
  ];
  async created() {
    this.innerShow = this.isShow;
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.initData();
  }
  @Watch("isShow")
  onIsShowChanged() {
    this.innerShow = this.isShow;
    if (this.innerShow) {
      this.initData();
    }
  }
  initData() {
    this.vm.ToUsers = ToUsersEnum.All;
    this.vm.Type = NotificationTypeEnum.Email;
    this.vm.Translatons = (this.languages || []).map(x => new PushMessageTranslationsRequest({
      LangCode: x
    }));    
  }
  @Watch("innerShow")
  onInnerShowChanged() {
    this.$emit("change", this.innerShow);
  }
  cancel() {
    this.innerShow = false;
  }
  onOk() {
    if (this.isLoading) {
      return;
    }
    const isValid = (this.$refs.pushValidator as any).isValid();
    if (!isValid) return;
    this.$emit('save', this.vm);
    // this.innerShow = false;
  }
}
